import LegalPageShell from "../components/legal/LegalPageShell";
import {
  CURRENT_PRIVACY_POLICY_VERSION,
  formatJapaneseLegalDate,
} from "../lib/legalConsent";

const sectionClassName = "space-y-3";
const headingClassName = "text-base font-bold text-[#5D4D46]";
const subheadingClassName = "font-bold text-[#5D4D46]";
const bulletListClassName = "list-disc space-y-2 pl-5";

export default function PrivacyPolicyPage() {
  return (
    <LegalPageShell>
      <h1 className="text-2xl font-bold text-[#5D4D46]">
        プライバシーポリシー（個人情報保護方針）
      </h1>

      <p>
        株式会社ウィズダムネットワークス（以下「当社」）は、当社の提供するサービス、および当社が行う事業（以下「本事業」）における、お客様および関係者の皆様の個人情報の取扱いについて、個人情報の保護に関する法律（以下「個人情報保護法」）および関連法令を遵守し、以下のとおりプライバシーポリシー（以下「本ポリシー」）を定めます。
      </p>

      <section className={sectionClassName}>
        <h2 className={headingClassName}>1. 事業者の名称・住所・代表者の氏名</h2>
        <p>株式会社ウィズダムネットワークス</p>
        <p>住所：請求があった場合には、法令に基づき遅滞なく開示します。</p>
        <p>代表取締役社長 伊藤 貴治</p>
      </section>

      <section className={sectionClassName}>
        <h2 className={headingClassName}>2. 個人情報の取得と利用目的</h2>
        <p>当社は、次の目的に必要な範囲で個人情報を取得・利用します。</p>
        <ul className={bulletListClassName}>
          <li>当社が提供するサービスの提供、契約の履行、本人確認、請求その他の事務手続きのため</li>
          <li>お客様およびお取引先からのお問い合わせ、ご相談、商談、打ち合わせおよび連絡への対応のため</li>
          <li>他の事業者から委託された業務を適切に遂行するため</li>
          <li>当社サービスに関する案内を行うため</li>
          <li>当社サービスの品質改善、利用状況の分析および新たなサービスの企画・開発のため</li>
          <li>WizMateにおけるAIによる回答生成、検索、資料・画像等の処理、会話・成果物の保存・再利用、品質確認、不具合調査および推薦機能の提供・改善のため</li>
          <li>不正利用の防止、セキュリティ対応、法令の遵守および当社または第三者の権利保護のため</li>
        </ul>
      </section>

      <section className={sectionClassName}>
        <h2 className={headingClassName}>3. 安全管理措置に関する事項</h2>
        <p>当社は、取り扱う個人データの漏えい、滅失または毀損の防止その他の安全管理のため、組織的・人的・物理的・技術的な安全管理措置を、事業規模および取扱状況に応じて講じます。</p>
      </section>

      <section className={sectionClassName}>
        <h2 className={headingClassName}>4. 第三者提供の制限</h2>
        <p>当社は、法令に基づく場合を除き、あらかじめご本人の同意を得ることなく個人情報を第三者に提供しません。</p>
      </section>

      <section className={sectionClassName}>
        <h2 className={headingClassName}>5. 業務委託および監督</h2>
        <p>当社は、利用目的の達成に必要な範囲内で、個人情報の取扱いを外部に委託する場合があります。この場合、個人情報の保護水準を満たしている委託先を選定し、適切な監督を行います。</p>
      </section>

      <section className={sectionClassName}>
        <h2 className={headingClassName}>6. 外国にある第三者への提供</h2>
        <p>当社が、クラウドサービスの利用等において外国（米国等）にあるサーバーに個人データを保管する場合、当該外国の個人情報保護制度を把握した上で、適切な安全管理措置を講じます。</p>
      </section>

      <section className={sectionClassName}>
        <h2 className={headingClassName}>7. WizMateにおけるAI・外部サービスの利用</h2>
        <p>WizMateは、機能の提供にあたり、AI、検索、資料・画像・音声の処理、クラウド保存その他の外部サービスを利用します。</p>
        <p>当社は、本サービスの提供に必要な範囲で、ユーザーの入力内容、会話履歴、アップロードされた文書・画像等の内容、これらから抽出または生成したテキスト、要約、関連箇所、URL、検索条件および生成結果等を、当社のシステムまたは外部サービスで処理または保存する場合があります。</p>
        <p>処理または保存の対象となる情報とその範囲は、利用する機能に応じて必要最小限に留めます。生成AI等による処理では、文書については原則として原本ではなく抽出した本文等を利用し、画像や音声の内容を読み取る機能では、画像または音声の内容を処理する場合があります。</p>
        <p>これらの情報が一般に公開され、または他のユーザーへ共有されるものではありません。</p>
        <p>ユーザーの明示的な同意がない限り、当社は、顧客データをWizMate独自モデルの学習、再学習またはfine-tuningに利用せず、外部AI事業者の汎用モデル学習へ任意提供しません。</p>
        <p>お問い合わせ対応、障害調査、セキュリティ対応、品質確認その他本ポリシーに定める目的に必要な場合、権限を有する担当者が必要な範囲で内容を確認することがあります。</p>
        <p>当社は、個別のお客様、利用者または案件を識別できない形に集計した情報を、サービス改善、利用傾向の分析、ランキング、推薦その他の目的で利用することがあります。</p>
      </section>

      <section className={sectionClassName}>
        <h2 className={headingClassName}>8. Google API サービスの利用とデータの取扱い</h2>
        <p>当社は、Googleカレンダー連携を利用する場合、通常会話で予定確認に回答するため、ユーザーの同意を得た上でGoogle OAuth 2.0を通じて以下のデータにアクセスします。本項はGoogle API Services User Data Policyに基づく開示です。</p>

        <h3 className={subheadingClassName}>（1）アクセスするデータ</h3>
        <ul className={bulletListClassName}>
          <li>基本プロフィール情報（openid / email / profile スコープ）：Googleアカウントのメールアドレス、氏名、プロフィール画像。WizMateアカウントとの連携確認に利用します。</li>
          <li>Googleカレンダーの予定情報（calendar.events.owned.readonly スコープ）：Googleカレンダー連携を利用する場合、当社は、通常会話で予定確認に回答するため、Googleカレンダー上の予定情報を読み取ります。予定の作成、変更、削除や自動調整は行いません。</li>
        </ul>

        <h3 className={subheadingClassName}>（2）利用目的</h3>
        <ul className={bulletListClassName}>
          <li>カレンダー連携：通常会話で予定確認に回答するために予定情報を読み取ります。予定の作成、変更、削除や自動調整は行いません。</li>
          <li>上記目的以外でGoogleアカウントデータを利用することはありません。</li>
        </ul>

        <h3 className={subheadingClassName}>（3）第三者への提供、および外部AIサービスとの連携</h3>
        <p>Googleアカウントから取得したデータを、広告目的で利用し、販売し、または貸与することはありません。本サービスの提供に必要な場合は、ユーザーに明示した機能の提供に必要な範囲で、当社のシステムまたは当社が利用する外部サービスに処理させることがあります。</p>
        <p>なお、本アプリケーションのAIエージェント処理において外部AIサービスを利用する場合がありますが、Google APIから取得したデータを、ユーザーの明示的な同意なく外部AI事業者の汎用モデル学習へ任意提供することはありません。</p>

        <h3 className={subheadingClassName}>（4）データの保存と保護</h3>
        <ul className={bulletListClassName}>
          <li>OAuthアクセストークンおよびリフレッシュトークンは、暗号化を施した上で安全なストレージに保管します。</li>
          <li>当社は、Googleよりアクセスを許可された目的以外にトークンを使用しません。</li>
        </ul>

        <h3 className={subheadingClassName}>（5）データの保存期間と削除</h3>
        <ul className={bulletListClassName}>
          <li>WizMateアプリ内で「外部連携設定を解除」すると、当社が保管しているアクセストークンおよびリフレッシュトークンを削除または無効化します。</li>
          <li>Googleアカウント側からも、Googleアカウント設定 → セキュリティ → サードパーティアクセスにて、WizMateへのアクセス権をいつでも取り消すことができます。</li>
          <li>メールアドレス等の連携記録を含むデータの削除をご希望の場合は、下記11項のお問い合わせ窓口よりご請求いただけます。法令に従い、合理的な範囲で速やかに対応いたします。</li>
        </ul>

        <p>
          本アプリケーションによるGoogle APIの利用は、
          <a
            href="https://developers.google.com/terms/api-services-user-data-policy"
            target="_blank"
            rel="noopener noreferrer"
            className="underline underline-offset-4"
          >
            Google API Services User Data Policy
          </a>
          に準拠します（Limited Use要件を含む）。
        </p>
      </section>

      <section className={sectionClassName}>
        <h2 className={headingClassName}>9. Cookie（クッキー）およびアクセス解析ツールの利用</h2>
        <p>当社ウェブサイトでは、利便性向上およびサイト利用状況の把握のため、CookieおよびGoogle Analytics等の解析ツールを使用しています。</p>
        <p>これらの技術により、Cookie等の識別子、端末・ブラウザ情報、閲覧・利用状況等が取得される場合があります。当社は、メールアドレスその他個人を直接特定する情報をアクセス解析ツールへ送信しないよう適切に運用します。</p>
      </section>

      <section className={sectionClassName}>
        <h2 className={headingClassName}>10. 個人情報の開示・訂正・利用停止等</h2>
        <p>お客様が、当社が保有する個人データの利用目的の通知、開示、内容の訂正・追加・削除、または利用の停止・消去を希望される場合は、下記お問い合わせ窓口までご連絡ください。法令に従い、合理的な範囲で速やかに対応いたします。</p>
      </section>

      <section className={sectionClassName}>
        <h2 className={headingClassName}>11. お問い合わせ窓口</h2>
        <p>個人情報の取扱いに関するご質問、または開示等の請求については、以下の窓口までご連絡ください。</p>
        <p>担当：株式会社ウィズダムネットワークス</p>
        <p>個人情報保護窓口：株式会社ウィズダムネットワークス</p>
        <p>
          メールアドレス：
          <a href="mailto:wizmate@wisdomnetworks.co.jp" className="underline underline-offset-4">
            wizmate@wisdomnetworks.co.jp
          </a>
        </p>
        <p>
          お問い合わせ：
          <a
            href="https://www.wisdomnetworks.co.jp"
            target="_blank"
            rel="noopener noreferrer"
            className="underline underline-offset-4"
          >
            https://www.wisdomnetworks.co.jp
          </a>
        </p>
      </section>

      <div className="border-t border-[#EADBC8] pt-6">
        <p>制定：2005年4月1日</p>
        <p>改訂：{formatJapaneseLegalDate(CURRENT_PRIVACY_POLICY_VERSION)}</p>
      </div>
    </LegalPageShell>
  );
}
